export default __webpack_public_path__ + "static/media/conversation.5b30b765.svg";